import React from 'react';
import { FadeIn } from './FadeIn';
import { ArrowRight } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-32 pb-20 md:pt-40 md:pb-28 bg-ivory overflow-hidden" data-id="element-416">
      {/* Decorative Background Elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden -z-10 pointer-events-none" data-id="element-417">
        <div className="absolute top-[-10%] right-[-5%] w-[50%] h-[50%] bg-gold/10 rounded-full blur-3xl" data-id="element-418"></div>
        <div className="absolute bottom-[-10%] left-[-5%] w-[40%] h-[40%] bg-forest/5 rounded-full blur-3xl" data-id="element-419"></div>

        {/* Large background text */}
        <div className="absolute top-10 left-0 text-[20vw] font-serif font-bold text-forest/[0.03] whitespace-nowrap select-none leading-none" data-id="element-420">
          ANIMA
        </div>

        {/* Graphic lines and dots */}
        <div className="absolute top-40 left-10 w-px h-32 bg-gradient-to-b from-gold/40 to-transparent" data-id="element-421"></div>
        <div className="absolute bottom-20 right-20 w-32 h-px bg-gradient-to-r from-forest/20 to-transparent" data-id="element-422"></div>
        <div className="absolute top-1/3 left-1/4 w-1.5 h-1.5 bg-gold/40 rounded-full" data-id="element-423"></div>
        <div className="absolute bottom-1/3 right-1/4 w-2 h-2 bg-forest/20 rounded-full" data-id="element-424"></div>
      </div>

      <div className="max-w-[1200px] mx-auto px-6 md:px-8" data-id="element-425">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center" data-id="element-426">
          {/* Left Side - Text (Centered on mobile, left on desktop, wait, prompt said "la hero textul si butonul sa fie centrate. lasa poza in dreapta". I will center text within its column) */}
          <div className="flex flex-col items-center lg:items-start text-center lg:text-left order-2 lg:order-1" data-id="element-427">
            <FadeIn data-id="element-428">
              <div className="inline-block border border-gold/40 rounded-full px-5 py-2 mb-6 bg-white/50 backdrop-blur-sm" data-id="element-429">
                <span className="font-display text-sm font-medium tracking-wider text-forest uppercase" data-id="element-430">
                  Program Online de 9 luni
                </span>
              </div>
            </FadeIn>

            <FadeIn delay={0.1} data-id="element-431">
              <h1 className="text-5xl md:text-6xl lg:text-7xl font-serif font-medium text-forest mb-6 leading-tight" data-id="element-432">
                ANIMA Recode
              </h1>
            </FadeIn>

            <FadeIn delay={0.2} data-id="element-433">
              <p className="text-xl md:text-2xl font-serif italic text-charcoal/80 mb-10 max-w-[500px]" data-id="element-434">
                Călătoria ta către încredere autentică
              </p>
            </FadeIn>

            <FadeIn delay={0.3} data-id="element-435">
              <a href="#aplica" className="inline-flex items-center justify-center px-8 py-4 rounded-full bg-forest text-ivory font-display text-lg font-medium hover:bg-forest-light transition-colors no-underline gap-3 group shadow-lg shadow-forest/20" data-id="element-436">
                Înscrie-te acum!
                <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-437" />
              </a>
            </FadeIn>
          </div>

          {/* Right Side - Square Image with creative elements */}
          <div className="order-1 lg:order-2 relative" data-id="element-438">
            <FadeIn direction="right" data-id="element-439">
              <div className="relative max-w-[500px] mx-auto" data-id="element-440">
                {/* Decorative offset frame behind photo */}
                <div className="absolute -top-5 -left-5 w-full h-full rounded-[24px] border-2 border-forest/30 -z-10" data-id="element-441"></div>
                <div className="absolute -bottom-5 -right-5 w-full h-full rounded-[24px] bg-gold/20 -z-20" data-id="element-442"></div>

                {/* Floating circles */}
                <div className="absolute -top-10 -right-10 w-24 h-24 border border-gold/50 rounded-full -z-10" data-id="element-443"></div>
                <div className="absolute top-1/4 -left-12 w-16 h-16 bg-forest/10 rounded-full blur-md -z-10" data-id="element-444"></div>
                <div className="absolute bottom-1/4 -right-8 w-20 h-20 bg-gold/20 rounded-full blur-md -z-10" data-id="element-445"></div>

                {/* Botanical SVG leaves - top right */}
                <svg className="absolute -top-8 -right-2 w-20 h-20 text-forest/40 -z-10" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-446">
                  <path d="M50 10 Q 70 30, 60 50 Q 50 70, 30 60 Q 50 50, 50 10" stroke="currentColor" strokeWidth="1.5" fill="currentColor" fillOpacity="0.15" data-id="element-447" />
                  <path d="M50 10 L 50 60" stroke="currentColor" strokeWidth="1" data-id="element-448" />
                </svg>

                {/* Botanical SVG leaves - bottom left */}
                <svg className="absolute -bottom-6 -left-6 w-24 h-24 text-gold-dark/50 -z-10 rotate-180" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-449">
                  <path d="M50 10 Q 70 30, 60 50 Q 50 70, 30 60 Q 50 50, 50 10" stroke="currentColor" strokeWidth="1.5" fill="currentColor" fillOpacity="0.2" data-id="element-450" />
                  <path d="M50 10 L 50 60" stroke="currentColor" strokeWidth="1" data-id="element-451" />
                </svg>

                {/* Small accent dots */}
                <div className="absolute top-8 -right-4 w-3 h-3 bg-forest rounded-full -z-10" data-id="element-452"></div>
                <div className="absolute -top-2 left-1/4 w-2 h-2 bg-gold-dark rounded-full -z-10" data-id="element-453"></div>
                <div className="absolute -bottom-2 right-1/3 w-2.5 h-2.5 bg-forest/60 rounded-full -z-10" data-id="element-454"></div>

                {/* Square photo */}
                <div className="rounded-[24px] overflow-hidden border-4 border-white shadow-2xl relative aspect-square" data-id="element-455">
                  <img src="https://cdn.magicpatterns.com/uploads/4eVh7z9fHhaphwPe5dnq7M/anima_recode_square.jpg" alt="ANIMA Recode - Călătoria ta către încredere autentică" className="w-full h-full object-cover" data-id="element-456" />
                  {/* Subtle gradient overlay */}
                  <div className="absolute inset-0 bg-gradient-to-t from-forest/15 to-transparent mix-blend-multiply pointer-events-none" data-id="element-457"></div>

                  {/* Corner badge */}
                  <div className="absolute top-4 left-4 bg-ivory/90 backdrop-blur-sm rounded-full px-3 py-1 border border-gold/30" data-id="element-458">
                    <span className="font-display text-[11px] font-semibold tracking-wider text-forest uppercase" data-id="element-459">
                      Mihaela Iovu
                    </span>
                  </div>
                </div>

                {/* Floating quote badge */}
                <div className="absolute -bottom-6 -left-4 md:-left-10 bg-white rounded-2xl px-5 py-3 shadow-xl border border-gold/30 z-10 max-w-[200px]" data-id="element-460">
                  <p className="font-serif italic text-forest text-[15px] leading-snug" data-id="element-461">
                    „De la <span className="font-semibold" data-id="element-462">funcționez</span> la{' '}
                    <span className="font-semibold" data-id="element-463">trăiesc</span>."
                  </p>
                </div>
              </div>
            </FadeIn>
          </div>
        </div>
      </div>
    </section>;
}